import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import { MainListItems } from "Components/listItems";
import LogoutMenu from "./logoutMenu";
import { useDispatch, useSelector } from "react-redux";
import { fetchBank } from "Redux/Actions/bankActions";
import { fetchPaymentType } from "Redux/Actions/paymentTypeAction";
import Loading from "Components/MUI_components/loading";
import { fetchStockLocation } from "Redux/Actions/stockLocation";

import DefaultLogo from "Components/DefaultLogo/DefaultLogo";
import AddCashInOut from "Components/Sales/POS/CashInOut/addCashInOut";

const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(9)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function MiniDrawer(props) {
  const user = useSelector((state) => state.auth);
  const theme = useTheme();

  const [open, setOpen] = React.useState(true);
  var pjson = require("../../../package.json");

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const dispatch = useDispatch();

  const [isLoaded, setIsLoaded] = React.useState(false);
  const [showPopup, setShowPopup] = React.useState(false);

  React.useEffect(() => {
    const fetchInitData = async () => {
      setIsLoaded(true);
      await dispatch(fetchBank());
      await dispatch(fetchPaymentType());
      await dispatch(fetchStockLocation());
      setIsLoaded(false);
      setShowPopup(true);
    };
    fetchInitData();
  }, [dispatch]);

  return (
    <>
      {isLoaded ? (
        <Loading text="Please wait.." noIcon={false} height={"100vh"} />
      ) : (
        <>
          <Box sx={{ display: "flex" }}>
            <CssBaseline />
            <AppBar position="fixed" open={open}>
              <Toolbar>
                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  onClick={handleDrawerOpen}
                  edge="start"
                  sx={{
                    marginRight: "36px",
                    ...(open && { display: "none" }),
                  }}
                >
                  <MenuIcon />
                </IconButton>
                <Typography variant="h6" noWrap component="div">
                  <p>
                    Version: {pjson.version} &nbsp;| &nbsp; Solution By Titum
                    (PVT) Ltd.
                  </p>
                </Typography>
                <LogoutMenu user={user?.userData.username} />
              </Toolbar>
            </AppBar>
            <Drawer variant="permanent" open={open}>
              <DrawerHeader
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <DefaultLogo />

                <IconButton onClick={handleDrawerClose}>
                  {theme.direction === "rtl" ? (
                    <ChevronRightIcon />
                  ) : (
                    <ChevronLeftIcon />
                  )}
                </IconButton>
              </DrawerHeader>
              <Divider />
              <List>
                <MainListItems />
              </List>
              <Divider />
            </Drawer>
            <Box
              component="main"
              sx={{ flexGrow: 1, p: 3 }}
              style={{ paddingTop: 85 }}
            >
              {props.children}
            </Box>
          </Box>

          {/* Popup Section */}
          {showPopup && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0,0,0,0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1300,
              }}
            >
              <div
                style={{
                  background: "white",
                  borderRadius: "10px",
                  textAlign: "center",
                  width: "800px",
                  maxWidth: "95%",
                  boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.3)",
                  zIndex: 1301,
                }}
              >
                <div
                  style={{
                    background: "#202335",
                    padding: "18px",
                    color: "#FFFFFF",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    overflow: "hidden",
                  }}
                >
                  <Typography variant="h6">
                    Friendly Reminder, Don't forget to Enter{" "}
                    <span style={{ fontWeight: 600, fontSize: "18px" }}>
                      Cash-In!
                    </span>
                  </Typography>

                  <span
                    style={{ marginRight: 20, cursor: "pointer" }}
                    onClick={() => setShowPopup(false)}
                  >
                    X
                  </span>
                </div>

                <div style={{ padding: "20px 0px" }}>
                  <AddCashInOut setOpen={setShowPopup} />
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
}
